import './DualRange.scss';
import Component from './DualRange';
export default Component;
